import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NnfHistoryComponent } from './nnf-history/nnf-history.component';
import { NnfModalComponent } from './nnf-modal/nnf-modal.component';
import { NnfRequestComponentComponent } from './nnf-request-component/nnf-request-component.component';
import { UserIdCreationComponentComponent } from './user-id-creation-component/user-id-creation-component.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpModule } from '../otp.module';

@NgModule({
  declarations: [NnfHistoryComponent, NnfModalComponent, NnfRequestComponentComponent,UserIdCreationComponentComponent] ,
  imports: [
    CommonModule,OtpModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule],
  
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class NnfModule { }
